import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const SendFormBackToFamilyMutation = graphql.persisted(
  "SendFormBackToFamily",
  graphql(`
    mutation SendFormBackToFamily($familyEnrollmentId: String!, $message: String) {
      sendFormBackToFamily(input: {familyEnrollmentId: $familyEnrollmentId, message: $message}) {
        familyEnrollment { id state }
        userErrors { message path }
      }
    }
  `)
);

export { SendFormBackToFamilyMutation };

export function useSendFormBackToFamily() {
  return useMutation(SendFormBackToFamilyMutation);
}
